import { UpdateIconButton, pn, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@compass/core";

import { ListBeProperty } from "components";
import { Permission, PermissionAction, ScholarshipStatusListDto, SortObject } from "generated/openApi";
import { useNavigate } from "react-router-dom";
import { isAuthorized } from "services";
import { ScholarshipTypeListResource } from "generated/openApi";
import { scholarshipStatusPageRoute } from "../ScholarshipStatusPage/ScholarshipStatusPage";

export const ScholarshipStatusTable = (props: {
    rootPermission: Permission;
    tableContainerRef: React.RefObject<HTMLDivElement>;
    scholarshipStatus: ScholarshipStatusListDto[];
    setScholarshipStatus: (scholarshipStatus: ScholarshipStatusListDto[]) => void;
    resource: ScholarshipTypeListResource;
    searchFocused: boolean;
    sortObjects: SortObject[] | undefined;
    sort: (sortObjects: SortObject[]) => void;
    loadList: () => void;
}) => {
    const navigate = useNavigate();
    const properties = props.resource.properties || [];

    return (
        <TableContainer ref={props.tableContainerRef}>
            <Table stickyHeader>
                <TableHead>
                    <TableRow>
                        <TableCell style={{ width: "7%"}}>
                            <ListBeProperty
                                listProperty={properties.find((x) => x.propertyName === pn<ScholarshipStatusListDto>("id"))}
                                searchFocused={props.searchFocused}
                                sortObjects={props.sortObjects}
                                onChange={(sortObjects) => props.sort(sortObjects)}
                            />
                        </TableCell>
                        <TableCell>
                            <ListBeProperty
                                listProperty={properties.find((x) => x.propertyName === pn<ScholarshipStatusListDto>("name"))}
                                searchFocused={props.searchFocused}
                                sortObjects={props.sortObjects}
                                onChange={(sortObjects) => props.sort(sortObjects)}
                            />
                        </TableCell>
                        <TableCell type="action"></TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    {props.scholarshipStatus.map((scholarshipStatusItem) => (
                        <TableRow
                            key={scholarshipStatusItem.id}
                            onClick={() =>
                                navigate(
                                    scholarshipStatusPageRoute.getPath({
                                        id: scholarshipStatusItem.id,
                                        crudMode: "view",
                                        screenType: "dialog"
                                    })
                                )
                            }
                        >
                            <TableCell>{scholarshipStatusItem.id}</TableCell>
                            <TableCell>{scholarshipStatusItem.name}</TableCell>
                            <TableCell type="action">
                                {isAuthorized(props.rootPermission, PermissionAction.Update) && (
                                    <UpdateIconButton color="primary"
                                        onClick={() =>
                                            navigate(
                                                scholarshipStatusPageRoute.getPath({
                                                    id: scholarshipStatusItem.id,
                                                    crudMode: "edit",
                                                    screenType: "dialog"
                                                })
                                            )
                                        }
                                    />
                                )}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};
